"use client";

import clsx from "clsx";
import { advanceScreen } from "@/lib/presenter/advanceScreen";
import { useTranslations } from "@/lib/compat/i18n";

/**
 * Screen 1.1 — Account creation. Email + MFA. The first lit module on
 * Al Madar's dashboard appears: "Profile · 1 of 7 lit."
 */
export function AccountCreation({ className }: { className?: string }) {
  const t = useTranslations("t1Registration");
  return (
    <div className={clsx("flex h-full items-center justify-center", className)}>
      <div className="glass w-[460px] p-6">
        <p className="font-mono text-[9px] uppercase tracking-[0.18em] text-orbitra-teal-soft">{t("accountStep")}</p>
        <h2 className="mt-1 font-display text-lg font-semibold text-orbitra-paper">{t("accountTitle")}</h2>
        <p className="mt-1 text-[12px] text-orbitra-teal-soft">{t("accountIntro")}</p>

        <Field label={t("accountFieldEmail")} value="ops@al-madar.ae" mono />
        <Field label={t("accountFieldMfa")}   value="• • • • • •"      mono />

        <label className="mt-4 flex items-center gap-2 text-[11px] text-orbitra-teal-soft">
          <span className="grid h-4 w-4 place-items-center rounded border border-state-verified bg-state-verified text-[10px] font-bold text-orbitra-ink">✓</span>
          {t("accountAuthCheckbox")}
        </label>

        <button type="button" onClick={advanceScreen} className="cta-primary mt-5 w-full py-2 text-[12px]">
          {t("accountContinueCta")}
        </button>
      </div>
    </div>
  );
}

function Field({ label, value, mono }: { label: string; value: string; mono?: boolean }) {
  return (
    <div className="mt-4">
      <p className="text-[9px] uppercase tracking-[0.18em] text-orbitra-muted">{label}</p>
      <div className={clsx("mt-1 rounded-md border border-state-verified/30 bg-orbitra-ink/60 px-3 py-2 text-[12px] text-orbitra-paper", mono && "font-mono")}>
        {value}
      </div>
    </div>
  );
}
